<template>
  <a-modal
    :centered="true"
    :confirmLoading="confirmLoading"
    :destroy-on-close="true"
    :maskClosable="false"
    :visible="visible"
    width="6.0002rem"
    @cancel="handleCancel"
    class="adjust-course-detail"
    footer=""
  >
    <a-icon class="close-icon" slot="closeIcon"/>
    <div ref="modalSelectRoot"></div>
    <a-spin :spinning="confirmLoading" class="login-parent">
      <div class="title">
        <div class="title-name">调课详情</div>
      </div>
      <a-form :form="form">
        <a-form-item label="原课程日期">
          <span>{{ record.sourceStartDate }}~{{ record.sourceFinishDate }}</span>
        </a-form-item>
        <a-form-item label="申请调课日期">
          <span>{{ record.targetStartDate }}~{{ record.targetFinishDate }}</span>
        </a-form-item>
        <a-form-item label="申请事由">
          <span>{{ record.reason }}</span>
        </a-form-item>
        <a-form-item
          label="证明材料">
          <a-table
            :columns="addColumns"
            :dataSource="record.attachmentList"
            :pagination="false"
            ref="table"
          >
            <span slot="addAction" slot-scope="text, record">
              <a @click="() => downloadFile(record)">下载</a>
            </span>
          </a-table>
        </a-form-item>
        <div class="footer-btn">
          <a-button @click="handleCancel" class="reset-btn">关闭</a-button>
        </div>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
  import { mapActions } from 'vuex'
  import AttachmentUpload from '@/components/AttachmentUpload/AttachmentUpload'
  import myCourse from '@/api/myCourse'

  export default {
    name: 'AdjustCourseDetail',
    props: {},
    components: {
      AttachmentUpload
    },
    data() {
      return {
        visible: false,
        options: [],
        confirmLoading: false,
        mdl: {},
        form: this.$form.createForm(this),
        record: {},
        addColumns: [
          {
            title: '附件名称',
            dataIndex: 'name'
          },
          {
            title: '操作',
            className: 'min-wid-s',
            scopedSlots: { customRender: 'addAction' }
          }
        ]
      }
    },
    beforeCreate() {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      ...mapActions(['GetInfo', 'GetUserData']),
      show(lastWholeCourseReassignId) {
        this.record = {}
        this.confirmLoading = true
        this.visible = true
        Promise.all([
          myCourse.reassignCourseDetail({id:lastWholeCourseReassignId}).then(res => {
            this.record = res.result
            this.confirmLoading = false
          })
        ])
      },
      handleCancel() {
        this.visible = false
      },
      downloadFile(record) {
        location.href = 'http://' + window.location.host + '/base/attachment/downloadAttachment' + '?id=' + record.id
      }
    },
    watch: {}
  }
</script>
<style lang="less">
  .adjust-course-detail {

    .close-icon {
      display: inline-block;
      width: 0.15rem;
      height: 0.15rem;
      background: url('../../../assets/icons/ic_login_close@2x.png')  center/100% 100% no-repeat;
    }

    .ant-modal-content {
      border-radius: 0.0975rem;
    }

    .title-line {
      border-bottom: 0.01rem solid;
      border-color: #c5cad2;
      margin-top: 0.18rem;
    }

    .ant-modal-header {
      border: 0; // 去掉标题下面的线
      border-radius: 0.0975rem 0.0975rem 0 0;
    }

    .ant-form label, .ant-form-item-children {
      font-size: 0.12rem;
    }

    .login-parent {
      padding: 0.15rem 0.375rem 0.06rem 0.24rem;

      .title {
        margin-bottom: 0.15rem;

        .title-name {
          font-weight: 600;
          color: #191d28;
          font-size: 0.2rem;
          line-height: 0.24rem;
        }
      }

      .ant-input {
        height: 0.435rem;
        border-radius: 0.0375rem;
        font-size: 0.135rem;
      }

      .footer-btn {
        margin-top: 0.3rem;
        text-align: center;

        .ant-btn-primary {
          width: 0.75rem;
          height: 0.3rem;
          background-color: rgba(23, 77, 244, 1);
          border-color: rgba(23, 77, 244, 1);
          color: rgba(255, 255, 255, 1);
          font-size: 0.135rem;
        }

        .reset-btn {
          width: 0.75rem;
          height: 0.3rem;
          margin-left: 0.195rem;
          background-color: rgba(0, 0, 0, 0);
          border-color: rgba(23, 77, 244, 1);
          color: rgba(23, 77, 244, 1);
          font-size: 0.135rem;
        }
      }

      .ant-form-item {
        display: flex;

        .ant-form-item-label {
          min-width: 0.825rem;
        }

        .ant-form-item-control-wrapper {
          flex: 1;
        }
      }
    }


  }
</style>
